__turbopack_context__.v({
  "icon": "Editable-module-scss-module__5LDXyq__icon",
});
